import { memo, useMemo } from "react";
import { generateColor } from "@/helpers/generateColor";
import type { MultiUser } from "@/multiManager";
import styles from "./PresentationMembers.module.scss";
import { UserAvatar } from "./UserAvatar";

type UserMonetsProps = {
    users: MultiUser[];
    viewerTokens: string[];
    presenterToken: string;
    currentUserToken: string;
    currentUserName: string;
    showLimit: number;
};

export const UserMonets = memo(
    ({
        users,
        viewerTokens,
        presenterToken,
        currentUserToken,
        currentUserName,
        showLimit,
    }: UserMonetsProps) => {
        const viewerSet = useMemo(() => new Set(viewerTokens), [viewerTokens]);

        const visibleUsers = useMemo(() => users.slice(0, showLimit), [users, showLimit]);

        return (
            <>
                {visibleUsers.map((user) => {
                    if (!viewerSet.has(user.token as string)) return null;

                    return (
                        <UserAvatar
                            key={user.sessionUID}
                            name={user.name}
                            color={user.color}
                            isPresenter={presenterToken === user.token}
                        />
                    );
                })}

                <div className={styles.barPanelRightUsersFirstItem}>
                    <UserAvatar
                        name={currentUserName}
                        color={generateColor(currentUserToken)}
                        isPresenter={presenterToken === currentUserToken}
                    />
                </div>
            </>
        );
    },
);
